import { render } from "./Sv013.vue?vue&type=template&id=3aa8059c&scoped=true"
import script from "./Sv013.vue?vue&type=script&lang=js"
export * from "./Sv013.vue?vue&type=script&lang=js"

import "./Sv013.vue?vue&type=style&index=0&id=3aa8059c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aa8059c"]])

export default __exports__